module.exports = "<h2 id=\"-ber-uns\">Über uns</h2>\n<p>Wir wünschen uns eine Atmosphäre, die es leicht macht,\nSchönes zu sehen, Feines zu schmecken und es sich gut gehen zu lassen.\nMit einer puren, fein nuancierten Küche,\ndie den selbstverständlichen Geschmack fokussiert.</p>\n";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy/about_de.md
// module id = Gwvo
// module chunks = 0